import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type SessionService from 'walden-trace-app/services/session';

export default class AuthCallbackRoute extends Route {
  @service('session') declare sessionService: SessionService;

  beforeModel() {
    return this.sessionService.validateCallbackAndRedirectToAttemptedUrl();
  }
}
